import { Divider, Flex } from '@chakra-ui/react';

import { COMMON_GAP } from '../../../../utils/styleUtil';
import ButtonDelete from '../../../generic/button/ButtonDelete';
import OptionCustom from '../options/OptionCustom';
import VariantParticipantDetails from '../VariantParticipantDetails';

const VariantLineCommonContent = ({ loggedUser, variant, allDefaultOptions, onVariantDelete, ...props }) => {
  return (
    <>
      {loggedUser && !variant.hasAccessControl && <Divider orientation="horizontal" mt=".9rem" mb=".9rem" />}
      {loggedUser && variant.hasAccessControl && (
        <VariantParticipantDetails participantDetails={variant.participantDetails} countOptions={variant.custom_options.length} />
      )}
      {!loggedUser && <VariantParticipantDetails participantDetails={variant.participantDetails} countOptions={variant.custom_options.length} />}

      <Flex flexFlow="wrap" gap={COMMON_GAP}>
        {variant.custom_options.map((option, index) => (
          <OptionCustom
            key={index}
            data={option}
            defaultOption={allDefaultOptions[index]}
            variantParticipants={variant.participant}
            participantDetails={variant.participantDetails}
            relatedSessionGroupId={variant.relatedSessionGroupId}
            {...props}
          />
        ))}
      </Flex>

      {props.index > 0 && <ButtonDelete onClick={() => onVariantDelete(props.index)} enableSpinner={false} />}
    </>
  );
};

export default VariantLineCommonContent;
